.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 5% 38px;
  text-align: center;
  min-height: 60vh;
}

.title {
  margin: 8px 0 0;
  font-size: 1.5rem;
}
